import React, { useContext, useState } from 'react';
import { Box, Grid, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import { HiOutlinePencil } from 'react-icons/hi';
import penEditIcon from '../../../../../../../../../../../assets/SvgIcons/resources/PenEdit.svg';
import { BsThreeDots } from 'react-icons/bs';
import ProfilePic from '../../../../../../../../../../../components/Common/ProfilePic';
import { LanguageContext } from '../../../../../../../../../../../libs/Context';
import NoData from '../../../../../../../../../../../components/Common/NoData';
import CreateContentNodataImg from '../../../../../../../../../../../assets/Resources/CreateContentNodataImg.svg';

const ActivitySlider = () =>
{
	const [ anchorEl, setAnchorEl ] = useState(null);
	// eslint-disable-next-line no-unused-vars
	const [ selectedId, setSelectedId ] = useState(null);
	const { language } = useContext(LanguageContext);
	const [ noData, setNoData ] = useState(true);

	const handleMenuOpen = (event, id) =>
	{
		setAnchorEl(event.currentTarget);
		setSelectedId(id);
	};

	const handleMenuClose = () =>
	{
		setAnchorEl(null);
		setSelectedId(null);
	};

	const todayTimelineData = [
		{
			id     : 1,
			type   : 'profile',
			user   : 'Vamsi',
			action : 'edited the file',
			time   : '11:32 AM',
			image  : 'https://i.pinimg.com/736x/19/a0/c3/19a0c3d7569d97fea2345726dc8bc551.jpg'
		},
		{
			id      : 2,
			type    : 'icon',
			user    : 'Raghu',
			action  : 'added as a',
			role    : 'Editor',
			time    : '11:32 AM',
			icon    : <HiOutlinePencil style={{ color: '#fff' }} fontSize={20} />,
			bgColor : '#2196F3'
		},
		{
			id     : 3,
			type   : 'profile',
			user   : 'Vamsi',
			action : 'edited the file',
			time   : '11:32 AM',
			image  : 'https://i.pinimg.com/736x/19/a0/c3/19a0c3d7569d97fea2345726dc8bc551.jpg'
		},
		{
			id      : 2,
			type    : 'svgIcon',
			user    : 'Raghu',
			action  : 'added as a',
			role    : 'Editor',
			time    : '11:32 AM',
			svgIcon : penEditIcon,
			bgColor : '#4CAF50'
		}
	];
	const PastTimelineData = [
		{
			id     : 1,
			type   : 'profile',
			user   : 'Vamsi',
			action : 'edited the file',
			time   : '11:32 AM',
			image  : 'https://i.pinimg.com/736x/19/a0/c3/19a0c3d7569d97fea2345726dc8bc551.jpg'
		},
		{
			id      : 2,
			type    : 'icon',
			user    : 'Raghu',
			action  : 'added as a',
			role    : 'Editor',
			time    : '11:32 AM',
			icon    : <HiOutlinePencil style={{ color: '#fff' }} fontSize={20} />,
			bgColor : '#2196F3'
		},
		{
			id      : 2,
			type    : 'svgIcon',
			user    : 'Raghu',
			action  : 'added as a',
			role    : 'Editor',
			time    : '11:32 AM',
			svgIcon : penEditIcon,
			bgColor : '#4CAF50'
		},
		{
			id     : 3,
			type   : 'profile',
			user   : 'Vamsi',
			action : 'edited the file',
			time   : '11:32 AM',
			image  : 'https://i.pinimg.com/736x/19/a0/c3/19a0c3d7569d97fea2345726dc8bc551.jpg'
		}
	];

	return (
		<Grid container>
			{!noData
				? (
					<>
						<Grid item xs={12} display={'flex'} sx={{ pb: 1 }} >
							<Typography variant='body2' fontWeight={'var(--font500)'}>{language?.today}</Typography>
						</Grid>
						<Grid item xs={12} direction={'column'}>
							<Timeline sx={{ paddingLeft: '0px !important' }}>
								{todayTimelineData.map((event, index) => (
									<TimelineItem key={event.id} sx={{ paddingLeft: '0px !important', '&::before': { display: 'none' }, '&:hover .three-dots-icon': { visibility: 'visible' } }}>
										<TimelineSeparator>
											{event.type === 'profile'
												? (
													<Box sx={{ height: '36px', width: '32px', borderRadius: '50%' }}>
														<ProfilePic
															defaultImg='https://i.pinimg.com/736x/19/a0/c3/19a0c3d7569d97fea2345726dc8bc551.jpg'
															className='brdrRadius50'
															src={event.svgIcon}
														/>
													</Box>
												)
												: 										 (
													<TimelineDot sx={{ backgroundColor: event.bgColor, margin: '0px' }}>
														{event.type === 'svgIcon'
															?																								(
																<Box component={'img'} src={event.svgIcon} sx={{ height: '24px', width: '22px', borderRadius: '50%' }} />
															)
															:																								(
																<Box width={24} height={24} display='flex' alignItems='center' justifyContent='center'>
																	{event.icon}
																</Box>
															)
														}

													</TimelineDot>)}
											{index !== PastTimelineData.length - 1 && (
												<TimelineConnector sx={{ borderStyle      : 'dashed',
													borderWidth      : '2px',
													borderTopWidth   : '0px',
													borderBottom     : '0px',
													borderRightWidth : '0px',
													borderColor      : '#bdbdbd',
													backgroundColor  : 'transparent' }}
												/>)}
										</TimelineSeparator>
										<TimelineContent sx={{ paddingTop: '0px !important' }}>
											<Stack direction={'row'} display={'flex'} justifyContent={'space-between'}>
												<Stack direction={'column'} spacing={1}>
													<Typography variant='body2' color='#737373'>
														{event.user} {event.action} {event.role && <span style={{ color: '#212121' }}>{event.role}</span>}
													</Typography>
													<Typography fontSize={'var(--pixel12)'} color={'#737373'}>{event.time}</Typography>
												</Stack>
												<Box
													className='three-dots-icon'
													sx={{ cursor: 'pointer', visibility: 'hidden' }} onClick={(eventItem) => handleMenuOpen(eventItem, event.id)}
												>

													<BsThreeDots style={{ color: '#717171' }} />
												</Box>

											</Stack>
										</TimelineContent>
									</TimelineItem>
								))}

							</Timeline>

						</Grid>
						<Grid item xs={12} display={'flex'} >
							<Typography variant='body2' fontWeight={'var(--font500)'} sx={{ pb: 1 }}>22 Jun 2024 </Typography>
						</Grid>
						<Grid item xs={12} direction={'column'}>
							<Timeline sx={{ paddingLeft: '0px !important' }}>
								{PastTimelineData.map((event, index) => (
									<TimelineItem key={event.id} sx={{ paddingLeft: '0px !important', '&::before': { display: 'none' }, '&:hover .three-dots-icon': { visibility: 'visible' } }}>
										<TimelineSeparator>
											{event.type === 'profile'
												? (
													<Box sx={{ height: '36px', width: '36px', borderRadius: '50%' }}>
														<ProfilePic
															defaultImg='https://i.pinimg.com/736x/19/a0/c3/19a0c3d7569d97fea2345726dc8bc551.jpg'
															className='brdrRadius50'
															src={event.svgIcon}
														/>
													</Box>
												)
												: 										 (
													<TimelineDot sx={{ backgroundColor: event.bgColor, margin: '0px' }}>
														{event.type === 'svgIcon'
															?																								(
																<Box component={'img'} src={event.svgIcon} sx={{ height: '24px', width: '24px', borderRadius: '50%' }} />
															)
															:																								(
																<Box width={24} height={24} display='flex' alignItems='center' justifyContent='center'>
																	{event.icon}
																</Box>
															)
														}

													</TimelineDot>)}
											{index !== PastTimelineData.length - 1 && (
												<TimelineConnector sx={{ borderStyle      : 'dashed',
													borderWidth      : '2px',
													borderTopWidth   : '0px',
													borderBottom     : '0px',
													borderRightWidth : '0px',
													borderColor      : '#bdbdbd',
													backgroundColor  : 'transparent' }}
												/>
											)}
										</TimelineSeparator>
										<TimelineContent sx={{ paddingTop: '0px !important' }}>
											<Stack direction={'row'} display={'flex'} justifyContent={'space-between'}>
												<Stack direction={'column'} spacing={1}>
													<Typography variant='body2' color='#737373'>
														{event.user} {event.action} {event.role && <span style={{ color: '#212121' }}>{event.role}</span>}
													</Typography>
													<Typography fontSize={'var(--pixel12)'} color={'#737373'}>{event.time}</Typography>
												</Stack>
												<Box
													className='three-dots-icon'
													sx={{ cursor: 'pointer', visibility: 'hidden' }} onClick={(eventItem) => handleMenuOpen(eventItem, event.id)}
												>

													<BsThreeDots style={{ color: '#717171' }} />
												</Box>

											</Stack>
										</TimelineContent>
									</TimelineItem>
								))}

							</Timeline>

						</Grid>
						<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
							<MenuItem onClick={handleMenuClose}>{language?.preview}</MenuItem>
							<MenuItem onClick={handleMenuClose}>{language?.restoreVersion}</MenuItem>
						</Menu>
					</>)
				: (
					<Box onClick={() => setNoData(false)} width={'100%'}>
						<NoData
							noDataHead='No activity available'
							color='lightTxt'
							src1={CreateContentNodataImg}
							heightimg='100px'
							height='80vh'
						/>
					</Box>)}
		</Grid>
	);
};

export default ActivitySlider;